
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const preferenceApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listPreferences: builder.query ({
      query: (params) => `v2/preference/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Preference"]
    }),
    getPreference: builder.query ({
      query: (preference_id) => `v2/preference/${preference_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Preference"]
    }),

    updatePreference: builder.mutation ({
      query: ({preference_id, data}) => ({
        url: `v2/preference/${preference_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Preference"]
    }),
    deletePreference: builder.mutation ({
      query: (preference_id) => ({
        url: `v2/preference/${preference_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Preference"]
    }),
    createPreference: builder.mutation ({
      query: (data) => ({
        url: `v2/preference/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Preference"]
    }),
  })
})


export const {
  useListPreferencesQuery,
  useLazyListPreferencesQuery,
  useGetPreferenceQuery,
  useLazyGetPreferenceQuery,

  useUpdatePreferenceMutation,
  useDeletePreferenceMutation,
  useCreatePreferenceMutation
} = preferenceApi
